export const REPORTYEARLYTURNOVERPERTEAM_SEARCH = 'REPORTYEARLYTURNOVERPERTEAM_SEARCH';
export const REPORTYEARLYTURNOVERPERTEAM_PAGE = 'REPORTYEARLYTURNOVERPERTEAM_PAGE';
export const REPORTYEARLYTURNOVERPERTEAM_YEAR = 'REPORTYEARLYTURNOVERPERTEAM_YEAR';
export const REPORTYEARLYTURNOVERPERTEAM_COMPANY = 'REPORTYEARLYTURNOVERPERTEAM_COMPANY';
export const REPORTYEARLYTURNOVERPERTEAM_CORPORATESECTOR = 'REPORTYEARLYTURNOVERPERTEAM_CORPORATESECTOR';
export const REPORTYEARLYTURNOVERPERTEAM_BRANCHASSOCIATION = 'REPORTYEARLYTURNOVERPERTEAM_BRANCHASSOCIATION';
export const REPORTYEARLYTURNOVERPERTEAM_PROFITMOTIVE = 'REPORTYEARLYTURNOVERPERTEAM_PROFITMOTIVE';
export const REPORTYEARLYTURNOVERPERTEAM_OPERATIVEAREA = 'REPORTYEARLYTURNOVERPERTEAM_OPERATIVEAREA';
